import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Button,
    Card,
    CardBody,
    Col,
    DropdownToggle,
    Row,
    UncontrolledDropdown,
    Container,
    DropdownMenu,
    DropdownItem,
    UncontrolledTooltip
} from "reactstrap";
import { getEntityDetails } from "http/fundLync/entityAndAddress.helper";

import Breadcrumbs from 'components/Common/BreadcrumbTitle';
import { getEntity, editEntity } from "../../http/fundLync/entityAndAddress.helper";
import { dateFormat, decryptedValue, isPermission } from "common/utility";
import TableContainerV1 from "components/Common/TableContainerV1";
import ToastDialog from "components/Common/ToastDialog";
import Switch from "react-switch";
const Offsymbol = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                fontSize: 12,
                color: "#fff",
                paddingRight: 2
            }}
        >
            {" "}
            No
        </div>
    );
};

const OnSymbol = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                fontSize: 12,
                color: "#fff",
                paddingRight: 2
            }}
        >
            {" "}
            Yes
        </div>
    );
};
const TableActionsComponent = (props, handleChange) => {
    const [checked, setChecked] = useState(props.assignedFlag);
    const newObj = {};
    for (const key in props) {
        if (props[key] !== null) {
            newObj[key] = props[key];
        }
    }
    useEffect(() => {
        setChecked(props.assignedFlag)
    }, [props]);
    return (
        <UncontrolledDropdown>
            <DropdownToggle tag="a" className="card-drop">
                <Switch
                    uncheckedIcon={<Offsymbol />}
                    checkedIcon={<OnSymbol />}
                    className="me-1 mb-sm-8 mb-2"
                    onColor="#21aa47"
                    onChange={() => {
                        newObj.assignedFlag = !props.assignedFlag
                        props.assignedFlag = !props.assignedFlag
                        setChecked(newObj.assignedFlag)
                        handleChange(newObj);
                    }}
                    checked={checked}
                    />
            </DropdownToggle>
        </UncontrolledDropdown>
    )
}


const FinancierEntity = (props) => {

    document.title = "List Financier | Fundlync";

    const navigate = useNavigate();
    const [entityList, setEntityList] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageCount: 0,
        totalRecords: 0,
    });
    const [pageSize, setPageSize] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const [columnId, setColumnId] = useState("id");
    const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const [isNewEntityPermission, setIsNewEntityPermission] = useState(false);
    const [sortingOptions, setSortingOptions] = useState({
        column: "id",
        isAsc: false,
        optionalColumn: ["Action", 'Assignment Flag'],
    });

    const filterType = 'Financier';
    let decodeFilterType = 'Financier'

    useEffect(() => {
        if (filterType) {
            getEntities({ searchKey: `${decodeFilterType}` })
        } else {
            getEntities()
        }
        checkPermissions();
    }, []);

    const handleMouseEnter = (event) => {
        event.target.style.color = "#34c38f";
        event.target.style.textDecoration = 'underline';
      };
    
      const handleMouseLeave = (event) => {
        event.target.style.color = "#21aa47";
        event.target.style.textDecoration = 'none';
      };

    const navigateToEditEntity = async (data) => {
        try {
            const entityId = data.id;
            try {
                const entityDetailsResponse = await getEntityDetails({ entityId });
                const entityType = entityDetailsResponse.data.entity_type;
                const user = decryptedValue(localStorage.getItem("user"));
                const encryptedId = btoa(entityId.toString());
                if (entityType === 'Customer') {
                    navigate(`/${user.roleName}/entity-Dashboard?id=${encodeURIComponent(encryptedId)}`);
                } else {
                    navigate(`/${user.roleName}/financierDetails?id=${encodeURIComponent(encryptedId)}`);
                }
            } catch (entityError) {
                console.error('Error fetching entity details:', entityError);
            }
        } catch (dealError) {
            console.log('Error fetching entity details:', dealError)
        }
    };

    const columns = useMemo(
        () => [
            {
                Header: "Id",
                accessor: "id",
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || '';
                },
            },
            {
                Header: "Financier Name",
                accessor: "entityName",
                filterable: true,
                Cell: (cellProps) => {
                    let rowData = cellProps?.row?.original
                    return (
                        <span onClick={() => { navigateToEditEntity(rowData) }}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                            style={{ cursor: 'pointer', color: '#21aa47' }}
                        >
                            {rowData?.entityName || ''}
                        </span>
                    );
                },
            },
            // {
            //     Header: "FI RM",
            //     accessor: row => {
            //       const firstName = row.fiPartnershipManagerUser?.first_name;
            //       const lastName = row.fiPartnershipManagerUser?.last_name;
            //       if (!firstName || !lastName) {
            //         return null;
            //       }
            //       return `${firstName} ${lastName}`;
            //     },
            //     filterable: true,
            //     Cell: (cellProps) => {
            //       return `${cellProps.value || ""}`;
            //     },
            // },
            {
                Header: "RM",
                accessor: row => {
                  const firstName = row.programOwnerUser?.first_name;
                  const lastName = row.programOwnerUser?.last_name;
                  if (!firstName || !lastName) {
                    return null;
                  }
                  return `${firstName} ${lastName}`;
                },
                filterable: true,
                Cell: (cellProps) => {
                  return `${cellProps.value || ""}`;
                },
            },
            {
                Header: "Onboarded Date",
                accessor: "createdAt",
                filterable: true,
                Cell: (cellProps) => {
                    return dateFormat(cellProps.value,"DD-MM-YYYY") || '';
                },
            },
            {
                Header: "Assignment Flag",
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return TableActionsComponent(rowData, handleChange);
                },
            },
            {
                Header: "Action",
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return TableActionComponent(rowData);
                },
            },
        ],
        []
    );

    const getEntities = data => {
        getEntity(data)
            .then(responseFromAPI => {
                if (responseFromAPI.status && responseFromAPI.code == 200) {
                    setEntityList(responseFromAPI.data.data)
                    const { totalItems, totalPages, currentPage } = responseFromAPI.data
                    setPagination({
                        pageIndex: currentPage,
                        pageCount: totalPages,
                        totalRecords: totalItems,
                    })
                } else {
                    setEntityList([])
                    setPagination({
                        pageIndex: 0,
                        pageCount: 0,
                        totalRecords: 0,
                    })
                }
            })
            .catch(error => { })
    }

    const handlePageChange = (page, pageSize, searchKey, columnName = columnId, sortingOrder = sortingOrderStatus) => {
        setPageSize(pageSize);
        if (filterType) {
            getEntities({ page, limit: pageSize, searchKey, columnName, sortingOrder, filterType: decodeFilterType })
        } else {
            getEntities({ page, limit: pageSize, searchKey, columnName, sortingOrder })
        }
    }

    const handleSortColumn = (option) => {
        setSortingOptions(option);
        const columnName = option.column;
        setColumnId(columnName);
        const sortingOrder = option.isAsc ? "asc" : "desc";
        setSortingOrderStatus(sortingOrder);
        handlePageChange(1, pageSize, searchValue, columnName, sortingOrder);
    };

    const handleSearchFilter = (value, pageSize) => {
        setSearchValue(value);
        handlePageChange(1, pageSize, value);
    };

    const handleClearSearch = () => {
        if (filterType) {
            setSearchValue(decodeFilterType);
            handlePageChange(1, pageSize, decodeFilterType);
        } else {
            setSearchValue("");
            handlePageChange(1, pageSize, "");
        }
    };

    const checkPermissions = async () => {
        const isNewEntitypermission = await isPermission(
            "entity_detail",
            "create_permission"
        );
        setIsNewEntityPermission(isNewEntitypermission);
    };

    const handleCustomerClicks = () => {
        const user = decryptedValue(localStorage.getItem("user"));
        navigate(`/${user.roleName}/addEntity?type=Financier`);
    };

    const handleChange = (data) => {
        editEntity(data)
            .then((response) => {
                if (response.code == 201 && response.status) {
                    setToastInfo({
                        message: "Entity Flag Updated",
                        showToast: true,
                        role: "success",
                    });
                } else {
                    const { message } = response;
                    setToastInfo({
                        message: message,
                        showToast: true,
                        role: "error",
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const buttonSection = (
        <div className="text-sm-end">
            {isNewEntityPermission && (
                <Button
                    type="button"
                    color="success"
                    className="btn-rounded mb-2 me-2"
                    onClick={handleCustomerClicks}>
                    <i className="mdi mdi-plus me-1" />
                    {'New Entity'}
                </Button>
            )}
        </div>
    );

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Financier List" />
                    <Row className="vertical-scroll">
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <TableContainerV1
                                        columns={columns}
                                        data={entityList}
                                        pagination={pagination}
                                        handlePageChange={handlePageChange}
                                        handleSearchFilter={handleSearchFilter}
                                        customSection={buttonSection}
                                        sortOptions={sortingOptions}
                                        handleSortColumn={handleSortColumn}
                                        handleClearSearch={handleClearSearch}
                                        className="custom-header-css"
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            ></ToastDialog>
        </React.Fragment>
    );
};

export default FinancierEntity;


const formatDate = (oldDate) => {
    const isoDateString = oldDate;
    const date = new Date(isoDateString);
    const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
    };
    const formattedDate = date.toLocaleDateString(undefined, options);

    return formattedDate;
};


const TableActionComponent = (props) => {
    const navigate = useNavigate();
    const user = decryptedValue(localStorage.getItem("user"));

    const navigateToEditRoles = (id) => {
        const encryptedId = btoa(id.id.toString());
        navigate(`/${user.roleName}/financierDetails?id=${encodeURIComponent(encryptedId)}`);
    };

    return (
        <UncontrolledDropdown>
            <DropdownToggle tag="a" className="card-drop">
                <i className="mdi mdi-dots-horizontal font-size-18"></i>
            </DropdownToggle>

            <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                    onClick={() => {
                        navigateToEditRoles(props);
                    }}
                >
                    <i
                        className="mdi mdi-eye font-size-16 text-success me-1"
                        id="viewTooltip"
                    ></i>
                    View
                    <UncontrolledTooltip placement="top" target="viewTooltip">
                        View
                    </UncontrolledTooltip>
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
    )
}